import React from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Sla from "./SLA/index";
import Feedback from "./Feedback";
import Objectives from "./CollatedObjectives";
import Thematic from "./Thematic";
import HeaderMenu from "../../../../Components/HeaderMenu";
import { Typography } from "@material-ui/core";
import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
  tabRoot: {
    "& .MuiTabs-flexContainer": {
      justifyContent: "flex-start",
    },
    "& .MuiTabs-indicator": {
      backgroundColor: "transparent",
    },
  },
  tabs: {
    color: "#1e1e1e",
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: "#ddd",
    backgroundColor: "rgba(7,127,131,.75)",
    borderTopLeftRadius: 5,
    borderTopRightRadius: 5,
    marginRight: 10,
    minWidth: 130,
    textTransform: "none",
    "&:hover,&.Mui-selected": {
      color: "#fff",
      backgroundColor: "rgba(7,127,131,1)",
      opacity: 1,
    },
  },
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <Box
      role='tabpanel'
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && children}
    </Box>
  );
}

export default function Caf() {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const globaluserData = useSelector(state => state.commonReducer)
  console.log("gg ud", globaluserData?.role
  )

  const tabArr =
    // sessionStorage.getItem("role") === "admin"
    globaluserData.role === "admin"
      ? ["Collated SLA", "Feedback", "Collated objectives"]
      : ["Collated SLA", "Feedback", "Collated objectives", "Thematic"];
  const tabPanelArr =
    // sessionStorage.getItem("role") === "admin"
    globaluserData?.role === "admin"
      ? [<Sla />, <Feedback />, <Objectives />]
      : [<Sla />, <Feedback />, <Objectives />, <Thematic />];

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      <HeaderMenu />
      <Box py={3} px={7}>
        <Grid>
          <Typography
            variant='h1'
            style={{ color: "#077f83", fontWeight: 700 }}
          >
            Reports
          </Typography>
        </Grid>
        <br />
        <Grid direction='row' justify='center' alignItems='center'>
          <Grid item xs={12}>
            <Box mb={5}>
              <Tabs
                value={value}
                onChange={handleChange}
                classes={{ root: classes.tabRoot }}
              >
                {tabArr.map((option) => (
                  <Tab classes={{ root: classes.tabs }} label={option} />
                ))}
              </Tabs>
              {tabPanelArr.map((option, index) => (
                <TabPanel value={value} index={index}>
                  {option}
                </TabPanel>
              ))}
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
